// extracted by mini-css-extract-plugin
module.exports = {"mainText":"home-page_mainText__2ARhQ","subText":"home-page_subText__7sKlW","bgImage":"home-page_bgImage__3pYAm"};